import React from 'react'
import { useIntl } from 'react-intl'
import { Box } from '@mui/material'
import Logo from '../../assets/img/dostyq-online.png'
import { sidebarLinks } from '../../utils/constants'
import { useAppSelector } from '../../app/hooks'
import BottomLinks from './components/BottomLinks'
import { MenuItem } from './components/MenuItem'
import { Main, Wrapper, logo, section } from './style'

declare module 'react' {
    interface HTMLAttributes<T> extends DOMAttributes<T> {
        openSideBar?: boolean
    }
}

const Sidebar = ({ openSideBar }) => {
    const { formatMessage } = useIntl()
    const userRole = useAppSelector(
        (state) => state.user.userInfo.roles[0] || 'noData',
    )

    const filteredLinks = sidebarLinks({ formatMessage }).filter((link) =>
        link.allowedRoles.includes(userRole),
    )

    return (
        <Wrapper openSideBar={openSideBar}>
            <Main>
                <Box sx={{ mb: 2.5 }}>
                    <img
                        alt="Dostyq Online"
                        src={Logo}
                        style={logo}
                    />
                </Box>

                <nav>
                    <ul>
                        <li>
                            <Box sx={section}>
                                {formatMessage({
                                    id: userRole,
                                })}
                            </Box>
                        </li>

                        {filteredLinks.map((link) => (
                            <MenuItem
                                key={link.id}
                                path={link.path}
                                title={link.title}
                            />
                        ))}
                    </ul>
                </nav>
            </Main>

            <BottomLinks userRole={userRole} />
        </Wrapper>
    )
}

export default Sidebar
